import { FileImageOutlined, HeartFilled, HeartOutlined } from "@ant-design/icons";
import { Card, Statistic } from "antd";
import { format } from "date-fns";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import ItemImage from '../../../assets/images/item_image.png';
import { useCareProductMutation, useUncareProductMutation } from "../../../redux/api/ProductApi";
import { useAppDispatch, useAppSelector } from "../../../redux/Hooks";
import { AuctionResponse } from "../../auction/types";
import { toggleLoginModal } from "../../login/redux/LoginSlice";

type CardProps = {
    price?: number,
    description?: string,
    item: AuctionResponse,
    reloadPage: () => void,
}

const ItemCardOther = ({ price, description, item, reloadPage }: CardProps) => {
    const [isFavoriteHovering, setIsFavoriteHovering] = useState(false);
    const navigate = useNavigate()

    const userState = useAppSelector(state => state.login);
    const dispatch = useAppDispatch();
    // const [isFavorite, setIsFavorite] = useState(false);

    const [uncareProduct] = useUncareProductMutation();
    const [careProduct] = useCareProductMutation();

    const generateCardMeta = () => {
        let title = (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <strong style={{ padding: '0px 15px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%', textAlign: 'center' }}>{item.productName}</strong>
                <span className="item-card-price-title">Giá khởi điểm</span>
                <div style={{ display: 'flex', alignItems: 'center', fontSize: 18, color: '#22C55E' }}>
                    <Statistic
                        value={item.startPrice}
                        groupSeparator="."
                        decimalSeparator=","
                        precision={0}
                        style={{ marginRight: 5 }}
                        valueStyle={{ fontFamily: 'Quicksand', color: '#22C55E', fontSize: 18 }} /> VNĐ
                </div>
            </div>
        )


        let description = (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>

                <span className="font-size-12" style={{ display: 'flex', justifyContent: 'center', marginBottom: 15 }}>
                    Thời gian đấu giá: <span style={{ marginLeft: 5 }}>{item.statute.startDate ? format(new Date(item.statute.startDate), "HH:mm dd/MM/yyyy") :
                        format(new Date(), "HH:mm dd/MM/yyyy")}</span>
                </span>
            </div>)

        return (<Card.Meta title={title} description={description} />)
    }

    const onFavoriteMouseOver = () => {
        setIsFavoriteHovering(true);
    }

    const onFavoriteMouseOut = () => {
        setIsFavoriteHovering(false);
    }

    const onFavoriteClick = () => {
        if (!userState.user.userId) {
            dispatch(toggleLoginModal())
        } else if (item.isCare) {
            // uncare
            uncareProduct({ productId: item.productId, statuteId: item.statute.statuteId }).unwrap().then(() => {
                reloadPage();
            })
        } else {
            // care
            careProduct({ productId: item.productId, statuteId: item.statute.statuteId }).unwrap().then(() => {
                reloadPage();
            })
        }
    }

    const redirectOnCardClick = () => {
        navigate(`/auction-item-other/${item.productId}/${item.statute.statuteId}`)
    }

    const cardImageElement = useMemo(() => {
        let cardUrl = process.env.REACT_APP_API_URL + `/files/downloadFile/`;

        if (item.vbAttachmentImages && item.vbAttachmentImages?.length) {
            let avatarIndex = item.vbAttachmentImages.findIndex(img => img.storageType === "avatar");
            cardUrl += avatarIndex !== -1 ? `${item.vbAttachmentImages[avatarIndex].attachmentId}` : `${item.vbAttachmentImages[0].attachmentId}`;
        } else {
            cardUrl = "";
        }

        if (cardUrl) {
            return (
                <img
                    style={{ objectFit: 'cover', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '15px 15px 0px 0px' }}
                    width='100%'
                    height='250px'
                    alt="example"
                    src={cardUrl}
                    className="item-card-cover" />
            )
        }

        return (
            <div style={{ width: '100%', height: 250, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <FileImageOutlined style={{ fontSize: 50 }} />
            </div>
        )
    }, [item.vbAttachmentImages])

    const generateCardCover = () => {
        return (
            <div
                className="item-card-cover"
            >
                <div className="item-card-action" style={{ justifyContent: 'flex-end' }}>
                    <div
                        style={{ alignSelf: 'center' }}
                        onMouseEnter={onFavoriteMouseOver}
                        onMouseLeave={onFavoriteMouseOut}
                        onClick={(e) => {
                            e.stopPropagation();
                            onFavoriteClick()
                        }}>
                        {isFavoriteHovering || item.isCare ?
                            <HeartFilled style={{ color: '#E59F17', fontSize: 25 }} /> :
                            <HeartOutlined style={{ color: 'white', fontSize: 25 }} />
                        }

                    </div>
                </div>
                {/* {isHovering ?
                    <div className="item-card-hover-action">
                        <div>Thời gian đấu giá:</div>
                        <div className="font-bold">
                            {item.startAuctionDate ? format(new Date(item.startAuctionDate), "dd/MM/yyyy - HH:mm") :
                                format(new Date(), "dd/MM/yyyy - HH:mm")}
                        </div>

                        <Space style={{ marginTop: 20 }}>
                            <Button className="button-gray font-size-16" onClick={redirectToDetail}>XEM CHI TIẾT</Button>
                        </Space>

                    </div> : <></>} */}

                {cardImageElement}
            </div>
        )
    }

    return (
        <>
            <Card
                hoverable
                style={{ borderRadius: '15px', maxWidth: 280, width: '100%' }}
                cover={generateCardCover()}
                onClick={redirectOnCardClick}
                className="custom-grid-card"
            >
                {generateCardMeta()}
            </Card>
        </>
    )
}

export default ItemCardOther;